var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7134 7.12811L18.4668 7.69379C18.2864 8.10792 17.7136 8.10792 17.5331 7.69379L17.2866 7.12811C16.8471 6.11947 16.0555 5.31641 15.0677 4.87708L14.308 4.53922C13.8973 4.35653 13.8973 3.75881 14.308 3.57612L15.0252 3.25714C16.0384 2.80651 16.8442 1.97373 17.2761 0.930831L17.5293 0.319531C17.7058 -0.10651 18.2942 -0.10651 18.4706 0.319531L18.7238 0.930831C19.1558 1.97373 19.9616 2.80651 20.9748 3.25714L21.6919 3.57612C22.1027 3.75881 22.1027 4.35653 21.6919 4.53922L20.9323 4.87708C19.9445 5.31641 19.1529 6.11947 18.7134 7.12811ZM8 2H12V4H8C4.68629 4 2 6.68629 2 10C2 13.61 4.46208 15.9656 10 18.4798V16H12C15.3137 16 18 13.3137 18 10H20C20 14.4183 16.4183 18 12 18V21.5C7 19.5 0 16.5 0 10C0 5.58172 3.58172 2 8 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChat);
export default __webpack_public_path__ + "static/media/ai-chat.d13073407b5c055487497ae30be05766.svg";
export { ForwardRef as ReactComponent };